export default "__VITE_ASSET__BRQ4VICm__"